import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "./unirse.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Mobile menu toggle
document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.querySelector("[data-action='open-menu']")
  const closeBtn = document.querySelector("[data-action='close-menu']")
  const menu = document.getElementById("mobile-menu")

  if (openBtn && closeBtn && menu) {
    openBtn.addEventListener("click", () => menu.classList.remove("hidden"))
    closeBtn.addEventListener("click", () => menu.classList.add("hidden"))
  }
})
